export default "__VITE_ASSET__Dwr3cxF5__"